import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import useApi from "src/utils/api/use-api";
import { sleep } from "src/utils/api/mock-utils";

const useTeamsApi = () => {
    const { user, userHasTeamsSubscription } = useAuth();

    const getMockData = async () => {
        await sleep();
        return [
            {
                id: "2e8ec9ea-d4c1-4adc-8a65-a5b6922a7369",
                name: "Twisted Sisters",
                membersCount: 13,
                ownerId: "6d737aa5-b8a5-464a-8e93-215f64d3b01b",
                isOwner: false,
                isMember: false,
                isPublic: true,
            },
            {
                id: "0ca162de-d14f-419c-a350-d3d9a40159aa",
                name: "Eagle's Fang",
                membersCount: 10,
                ownerId: user.id,
                isOwner: true,
                isMember: true,
                isPublic: true,
            },
            {
                id: "0ca162de-d14f-419c-a350-d3d9a40159ab",
                name: "Non Team",
                membersCount: 10,
                ownerId: "6d737aa5-b8a5-464a-8e93-215f64d3b01b",
                isOwner: false,
                isMember: true,
                isPublic: true,
            },
            {
                id: "dd886a3c-63b4-40aa-a4fb-cf4b50e34125",
                name: "Orgon Accumulator",
                membersCount: 3,
                ownerId: "6d737aa5-b8a5-464a-8e93-215f65d3b92a",
                isOwner: false,
                isMember: true,
                isPublic: true,
            },
            {
                id: "dd886a3c-63b4-40aa-a4fb-cf4b50e34126",
                name: "Pizza Donors",
                membersCount: 20,
                ownerId: "6d737aa5-b8a5-464a-8e93-215f65d3b92a",
                isOwner: true,
                isMember: true,
                isPublic: true,
            },
        ];
    };
    if (!userHasTeamsSubscription) return useApi(() => getMockData());
    return useApi(() => request("/api/teams"));
};

export default useTeamsApi;
